<template>
  <div id="body" style="text-align: left;height: 100%;">
    <div id="header"><h1>Server Error</h1></div>
    <div id="content">
    <div class="content-container"><fieldset>
      <h2>404.8 - URL namespace hidden.</h2>
      <h3>The namespace of the specified URL is hidden by configuration.</h3>
    </fieldset></div>
    </div>
  </div>
</template>

<script>
 export default {
   name: 'p404',
   data() {
     return {
     }
   },
   computed: {
     message() {
       return '页面找不到了......'
     }
   }
 }
</script>

<style lang="css" scoped>
#body{margin:0;font-size:.7em;font-family:Verdana, Arial, Helvetica, sans-serif;background:#EEEEEE;}
fieldset{padding:0 15px 10px 15px;} 
h1{font-size:2.4em;margin:0;color:#FFF;}
h2{font-size:1.7em;margin:0;color:#CC0000;} 
h3{font-size:1.2em;margin:10px 0 0 0;color:#000000;} 
#header{width:96%;margin:0 0 0 0;padding:6px 2% 6px 2%;font-family:"trebuchet MS", Verdana, sans-serif;color:#FFF;
background-color:#555555;}
#content{margin:0 0 0 2%;position:relative;}
.content-container{background:#FFF;width:96%;margin-top:8px;padding:10px;position:relative;}
</style>
